'use client';

import { useTranslation } from 'next-i18next';

/**
 * @description Weekly voice-search hint, anchored above the prompt input (nearest
 * `relative` ancestor). Visibility and the 7-day/4-second gating live in
 * `useVoiceToText` — render this only while `isHintVisible`.
 */
export const VoiceHintBubble = () => {
  const { t } = useTranslation('common');

  return (
    <div
      role="status"
      className="absolute bottom-full left-0 z-10 mb-4 max-w-xs animate-pop-up rounded-xl border border-input bg-surface px-3 py-2 text-xs leading-normal text-ink shadow-lg md:text-sm"
    >
      {t('global.voice.hint', 'Speak now - press stop and your words will fill the input.')}
    </div>
  );
};
